import { defineStore } from "pinia";
import { ref } from "vue";

import { FeatureTeaser, ViewedItem } from "shared/resources";
import { useUserStore } from "shared/stores/user";

export const useFeatureTeasersStore = defineStore("featureTeasers", () => {
  const featureTeasers = ref<FeatureTeaser[]>([]);

  function findFeatureId(featureName: string) {
    return Number(findFeature(featureName)?.id);
  }

  function findFeature(featureName: string) {
    return featureTeasers.value.find(
      (featureTeaser) => featureTeaser.featureName === featureName
    );
  }

  function setFeatureTeasers(newFeatureTeasers: FeatureTeaser[]) {
    featureTeasers.value = newFeatureTeasers;
  }

  function fetchFeatureTeasers() {
    const viewedItemScope = ViewedItem.where({
      targetType: "FeatureTeaser",
      userId: useUserStore().currentUser.id,
    }).order({ viewedAt: "desc" });

    FeatureTeaser.includes(["viewedItems"])
      .where({
        featureName: [
          "share_online_broadcast",
          "has_instant_edit_media_item",
          "has_instant_edit_transcript",
          "has_social_platform",
        ],
      })
      .merge({ viewedItems: viewedItemScope })
      .all()
      .then((response) => {
        setFeatureTeasers(response.data);
      })
      .catch(() => {
        // do nothing
      });
  }

  return {
    featureTeasers,

    fetchFeatureTeasers,
    findFeature,
    findFeatureId,
  };
});

export default useFeatureTeasersStore;
